/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deal_Payments_HintInputs */

const cs_deal_payments_hint = /** @type {(inputs: Deal_Payments_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zálohy, provize a další platby k obchodu.`)
};

const en_deal_payments_hint = /** @type {(inputs: Deal_Payments_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deposits, commissions, and other deal payments.`)
};

/**
* | output |
* | --- |
* | "Deposits, commissions, and other deal payments." |
*
* @param {Deal_Payments_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_payments_hint = /** @type {((inputs?: Deal_Payments_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Payments_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_payments_hint(inputs)
	return cs_deal_payments_hint(inputs)
});